<template>

    <v-dialog v-model="weatherDialog" width="600" class="mt-2">
      <v-card>
          <v-card-title
          class="headline grey lighten-2"
          primary-title
          >
          <v-icon medium>info</v-icon> Google weather report
          </v-card-title>

          <v-card-text>
              <h2>מזג האוויר בגוגל ישראל</h2>
              <p>הגרף שלפניכם מציג את שינויי מזג האוויר היומיים בגוגל ישראל, תוך התייחסות לכלל הביטויים</p>
              <p>הקיימים במערכת וללא קשר לחשבון כזה או אחר. ככל שהטמפרטורה היומית גבוהה יותר, כך רמת</p>
              <p>התנודתיות של תוצאות החיפוש בגוגל גבוהה גם היא</p>
              <p style="font-weight: bold;">הטמפרטורה היומית נקבעת לפי 4 פרמטרים (המיוצגים ע"י הצבעים השונים):</p>
              <p>ירוק – אתרים שעלו בדירוג בתוצאות החיפוש</p>
              <p>צהוב - אתרים שירדו בדירוג בתוצאות החיפוש</p>
              <p>כתום - אתרים שנכנסו לדף התוצאות הראשון</p>
              <p>אדום – רמת התנודתיות היומית של התוצאות</p>
              <p>הכפתורים שבצדו הימני העליון של הגרף מאפשרים להציג או להסתיר את כל אחד מהנתונים הנ"ל</p>
              <p>לפי בחירה</p>
              <p>החיבור של ארבעת הנתונים יחדיו נותן את התוצאה במעלות צלזיוס, כאשר הטמפרטורה ביום </p>
              <p>סטנדרטי בגוגל נעה בין 20-25 מעלות</p>
              <p>כאשר הטמפרטורה מגיעה ל-30-35 מעלות ניתן לראות זאת כסימן להתפתחות שכדאי לעקוב</p>
              <p>אחריה, וב-36 מעלות ומעלה מדובר ככל הנראה בעדכון גוגל משמעותי.</p>
              <p>במהלך היום, ניתן לראות שהעמודה האחרונה מצד ימין (המייצגת את היום הנוכחי) משתנה. זאת</p>
              <p>מכיוון שהמערכת מתעדכנת בזמן אמת - בשעות הבוקר היא מספקת תחזית יומית, המתעדכנת</p>
              <p>בנתונים מדויקים יותר בסביבות השעה 16:30 ומגיעה לחישוב סופי ומדויק לאחר השעה 24:00 של</p>
              <p>אותו יום</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="close" flat @click="closeModal()">Close</v-btn>
          </v-card-actions>
      </v-card>
      </v-dialog>

</template>

<script>
export default {
  name: 'WeatherModal',
  props: ['weatherDialog', 'loading'],
  methods: {
    closeModal () {
      this.$parent.$emit('weatherDialog', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/weather-modal/WeatherModal.vue